export default __webpack_public_path__ + "static/media/create_icon.acbe37ae.svg";